/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function fancyTitles() {
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  // alert(viewportWidth);
  if (viewportWidth > 960) {
    // calculate what the transform value should be
    var containerWidth = $('.fancyTitle--parent').width() + 'px';
    $('.fancyTitle').css('transform', 'translate(calc(-60vw + ' + containerWidth + '), 0)');
  } else {
    $('.fancyTitle').css('transform', 'translate(0, -40%)');
  }
  setTimeout(() => {
    $('.fancyTitle').addClass('show');
  }, 500);
}
